import { ColDef, ITextFilterParams } from "ag-grid-community";

export const textFilterParams: ITextFilterParams = {
	debounceMs: 200,
	maxNumConditions: 10,
	filterOptions: ["equals", "notEqual", "blank", "notBlank"],
};

/**
 * Text column type for the ag-grid.
 */
export const UUIDColumn: ColDef = {
	filter: "agTextColumnFilter",
	floatingFilter: true,
	filterParams: textFilterParams,
	// Enables the column to be edited.
	// editable: true,
	// cellEditor: "agTextCellEditor",
	// cellEditorParams: {
	//   maxLength: 20
	// }
};
